(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-media-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.custom-media-grid__description p').forEach(p => {
    const text = p.textContent.trim();
    if (text && text[0] === text[0].toLowerCase()) {
      p.classList.add('custom-media-grid__description--paragraph-starts-lower');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
